import request from '@/utils/request'

// 项目访谈模块接口
// 项目中一些基础公共配置数据获取,每个接口中的：takePeeridAndSessionid代表需要把peerid和sessionid都加进参数里，在request.js里统一处理，不再每个接口里都加这2个字段
export default {
  // 项目访谈-并购标的/融资项目-栏目
  interviewMenu: (data) => {
    return request({
      data,
      url: `/project/due/edit_due_dili_item_list`,
      method: 'GET',
      takePeeridAndSessionid: true
    })
  },
  // 项目访谈-并购标的/融资项目-获取各栏目详情
  interviewItemInfo: (data) => {
    return request({
      data,
      url: `/project/due/item_content_detail`,
      method: 'GET',
      takePeeridAndSessionid: true
    })
  },
  // 项目访谈-并购标的/融资项目-添加自定义栏目
  addCustomItem: (data) => {
    return request({
      data,
      url: `/project/due/add_custom_due_dili_item`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      takePeeridAndSessionid: true
    })
  },
  // 项目访谈-并购标的/融资项目-删除自定义栏目
  delCustomItem: (data) => {
    return request({
      data,
      url: `/project/due/delete_custom_due_dili_item`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      takePeeridAndSessionid: true
    })
  },
  // 项目访谈-并购标的/融资项目-添加栏目附件
  saveInterviewFile: (data) => {
    return request({
      data,
      url: `/project/due/item_resource_save`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      takePeeridAndSessionid: true
    })
  },
  // 项目访谈-并购标的/融资项目-删除栏目附件（可批量删除）
  delInterviewFile: (data) => {
    return request({
      data,
      url: `/project/due/delete_due_dili_item_resources`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      takePeeridAndSessionid: true
    })
  },
  // 项目访谈-并购标的/融资项目-预览报告
  previewDue: (data) => {
    return request({
      data,
      url: `/project/due/preview_due_dili_item_list`,
      method: 'GET',
      takePeeridAndSessionid: true
    })
  },
  // 项目访谈-并购标的/融资项目-保存栏目
  saveProjectItem: (data) => {
    return request({
      data,
      url: `/project/due/item_content_info_save`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      takePeeridAndSessionid: true
    })
  }
}
